const COUNTRY_CODE_MAP = {
  "Afghanistan": "AF",
  "Albania": "AL",
  "Algeria": "DZ",
  "Andorra": "AD",
  "Angola": "AO",
  "Antigua and Barbuda": "AG",
  "Argentina": "AR",
  "Armenia": "AM",
  "Australia": "AU",
  "Austria": "AT",
  "Azerbaijan": "AZ",
  "Bahamas": "BS",
  "Bahrain": "BH",
  "Bangladesh": "BD",
  "Barbados": "BB",
  "Belarus": "BY",
  "Belgium": "BE",
  "Belize": "BZ",
  "Benin": "BJ",
  "Bhutan": "BT",
  "Bolivia": "BO",
  "Bosnia and Herzegovina": "BA",
  "Botswana": "BW",
  "Brazil": "BR",
  "Brunei": "BN",
  "Bulgaria": "BG",
  "Burkina Faso": "BF",
  "Burundi": "BI",
  "Cambodia": "KH",
  "Cameroon": "CM",
  "Canada": "CA",
  "Cape Verde": "CV",
  "Central African Republic": "CF",
  "Chad": "TD",
  "Chile": "CL",
  "China": "CN",
  "Colombia": "CO",
  "Comoros": "KM",
  "Congo": "CG",
  "Costa Rica": "CR",
  "Croatia": "HR",
  "Cuba": "CU",
  "Cyprus": "CY",
  "Czech Republic": "CZ",
  "Denmark": "DK",
  "Djibouti": "DJ",
  "Dominica": "DM",
  "Dominican Republic": "DO",
  "East Timor": "TL",
  "Ecuador": "EC",
  "Egypt": "EG",
  "El Salvador": "SV",
  "Equatorial Guinea": "GQ",
  "Eritrea": "ER",
  "Estonia": "EE",
  "Ethiopia": "ET",
  "Fiji": "FJ",
  "Finland": "FI",
  "France": "FR",
  "Gabon": "GA",
  "Gabonese Republic": "GA",
  "Gambia": "GM",
  "Georgia": "GE",
  "Germany": "DE",
  "Ghana": "GH",
  "Greece": "GR",
  "Grenada": "GD",
  "Guatemala": "GT",
  "Guinea": "GN",
  "Guinea-Bissau": "GW",
  "Guyana": "GY",
  "Haiti": "HT",
  "Honduras": "HN",
  "Hungary": "HU",
  "Iceland": "IS",
  "India": "IN",
  "Indonesia": "ID",
  "Iran": "IR",
  "Iraq": "IQ",
  "Ireland": "IE",
  "Israel": "IL",
  "Italy": "IT",
  "Jamaica": "JM",
  "Japan": "JP",
  "Jordan": "JO",
  "Kazakhstan": "KZ",
  "Kenya": "KE",
  "Kiribati": "KI",
  "Korea, North": "KP",
  "North Korea": "KP",
  "Korea, South": "KR",
  "South Korea": "KR",
  "Korea": "KR",
  "Kuwait": "KW",
  "Kyrgyzstan": "KG",
  "Laos": "LA",
  "Latvia": "LV",
  "Lebanon": "LB",
  "Lesotho": "LS",
  "Liberia": "LR",
  "Libya": "LY",
  "Liechtenstein": "LI",
  "Lithuania": "LT",
  "Luxembourg": "LU",
  "Macedonia": "MK",
  "Madagascar": "MG",
  "Malawi": "MW",
  "Malaysia": "MY",
  "Maldives": "MV",
  "Mali": "ML",
  "Malta": "MT",
  "Marshall Islands": "MH",
  "Mauritania": "MR",
  "Mauritius": "MU",
  "Mexico": "MX",
  "Micronesia": "FM",
  "Moldova": "MD",
  "Monaco": "MC",
  "Mongolia": "MN",
  "Montenegro": "ME",
  "Morocco": "MA",
  "Mozambique": "MZ",
  "Myanmar": "MM",
  "Namibia": "NA",
  "Nauru": "NR",
  "Nepal": "NP",
  "Netherlands": "NL",
  "New Zealand": "NZ",
  "Nicaragua": "NI",
  "Niger": "NE",
  "Nigeria": "NG",
  "Norway": "NO",
  "Oman": "OM",
  "Pakistan": "PK",
  "Palau": "PW",
  "Panama": "PA",
  "Papua New Guinea": "PG",
  "Paraguay": "PY",
  "Peru": "PE",
  "Philippines": "PH",
  "Poland": "PL",
  "Portugal": "PT",
  "Qatar": "QA",
  "Romania": "RO",
  "Russia": "RU",
  "Rwanda": "RW",
  "Saint Kitts and Nevis": "KN",
  "Saint Lucia": "LC",
  "Saint Vincent and the Grenadines": "VC",
  "Samoa": "WS",
  "San Marino": "SM",
  "Sao Tome and Principe": "ST",
  "Saudi Arabia": "SA",
  "Senegal": "SN",
  "Serbia": "RS",
  "Seychelles": "SC",
  "Sierra Leone": "SL",
  "Singapore": "SG",
  "Slovakia": "SK",
  "Slovenia": "SI",
  "Solomon Islands": "SB",
  "Somalia": "SO",
  "South Africa": "ZA",
  "South Sudan": "SS",
  "Spain": "ES",
  "Sri Lanka": "LK",
  "Sudan": "SD",
  "Suriname": "SR",
  "Swaziland": "SZ",
  "Sweden": "SE",
  "Switzerland": "CH",
  "Syria": "SY",
  "Taiwan": "TW",
  "Tajikistan": "TJ",
  "Tanzania": "TZ",
  "Thailand": "TH",
  "Togo": "TG",
  "Tonga": "TO",
  "Trinidad and Tobago": "TT",
  "Tunisia": "TN",
  "Turkey": "TR",
  "Turkmenistan": "TM",
  "Tuvalu": "TV",
  "Uganda": "UG",
  "Ukraine": "UA",
  "United Arab Emirates": "AE",
  "United Kingdom": "GB",
  "United States": "US",
  "Uruguay": "UY",
  "Uzbekistan": "UZ",
  "Vanuatu": "VU",
  "Vatican City": "VA",
  "Venezuela": "VE",
  "Vietnam": "VN",
  "Yemen": "YE",
  "Zambia": "ZM",
  "Zimbabwe": "ZW",
  
  // Additional territories and dependencies
  "American Samoa": "AS",
  "Anguilla": "AI",
  "Aruba": "AW",
  "Bermuda": "BM",
  "Bonaire": "BQ",
  "British Indian Ocean Territory": "IO",
  "British Virgin Islands": "VG",
  "Cayman Islands": "KY",
  "Christmas Island": "CX",
  "Cocos (Keeling) Islands": "CC",
  "Cook Islands": "CK",
  "Curacao": "CW",
  "Falkland Islands": "FK",
  "Faroe Islands": "FO",
  "French Guiana": "GF",
  "French Polynesia": "PF",
  "Gibraltar": "GI",
  "Greenland": "GL",
  "Guadeloupe": "GP",
  "Guam": "GU",
  "Hong Kong": "HK",
  "Isle of Man": "IM",
  "Jersey": "JE",
  "Macao": "MO",
  "Martinique": "MQ",
  "Mayotte": "YT",
  "Montserrat": "MS",
  "New Caledonia": "NC",
  "Niue": "NU",
  "Norfolk Island": "NF",
  "Northern Mariana Islands": "MP",
  "Palestine": "PS",
  "Pitcairn": "PN",
  "Puerto Rico": "PR",
  "Reunion": "RE",
  "Saint Barthelemy": "BL",
  "Saint Helena": "SH",
  "Saint Martin": "MF",
  "Saint Pierre and Miquelon": "PM",
  "Sint Maarten": "SX",
  "South Georgia": "GS",
  "Svalbard and Jan Mayen": "SJ",
  "Tokelau": "TK",
  "Turks and Caicos Islands": "TC",
  "U.S. Virgin Islands": "VI",
  "Wallis and Futuna": "WF",
  "Western Sahara": "EH",

  // Alternative names and common variations
  "United States of America": "US",
  "USA": "US",
  "UK": "GB",
  "Great Britain": "GB",
  "England": "GB",
  "Scotland": "GB",
  "Wales": "GB",
  "Northern Ireland": "GB",
  "Republic of Ireland": "IE",
  "Eire": "IE",
  "Republic of Korea": "KR",
  "Democratic People's Republic of Korea": "KP",
  "Russian Federation": "RU",
  "Czechia": "CZ",
  "Chinese Taipei": "TW",
  "Burma": "MM",
  "Congo-Brazzaville": "CG",
  "Congo-Kinshasa": "CD",
  "Democratic Republic of the Congo": "CD",
  "DR Congo": "CD",
  "DRC": "CD",
  "Republic of the Congo": "CG",
  "Ivory Coast": "CI",
  "Cote d'Ivoire": "CI",
  "Timor-Leste": "TL",
  "Eswatini": "SZ",
  "Vatican": "VA",
  "Holy See": "VA",
  "Islamic Republic of Iran": "IR",
  "Lao People's Democratic Republic": "LA",
  "North Macedonia": "MK",
  "Republic of Moldova": "MD",
  "Palestine State": "PS",
  "State of Palestine": "PS",
  "Syrian Arab Republic": "SY",
  "Bolivarian Republic of Venezuela": "VE",
  "Viet Nam": "VN",

  // Common misspellings or variations
  "Columbia": "CO",
  "Phillipines": "PH",
  "Brasil": "BR",
  "Virgin Islands": "VI",
  "Channel Islands": "GB",
  "Kosovo": "XK",
  "Netherlands Antilles": "AN"
};

export default COUNTRY_CODE_MAP;